import { Size } from '@app/components/avatar/avatar.component';
import { ApprovalInstanceStep } from '@models/approvals/approval-instance-step.model';
import { ChangeRequest } from '@models/change-requests/change-request.model';
import { Employee } from '@models/employee/employee.model';
import { MultiAvatarColumn } from '@table/classes/multi-avatar-column.class';
import { CellDisplay } from '@table/enums/cell-display.enum';

export class ApproversColumn extends MultiAvatarColumn<ChangeRequest> {
    title = 'change-requests.logTable.approvers';
    type: CellDisplay = CellDisplay.singleAndMultiAvatar;
    sortable = false;
    size: Size = 'medium';
    property = 'approvers';

    getEmployees(changeRequest: ChangeRequest): Employee[] {
        return changeRequest.approvalInstance.steps.map((step: ApprovalInstanceStep) => {
            return step.employee;
        });
    }

    getMaximumEmployeesToShow(): number {
        return 5;
    }
}
